export const setItem = (key, value) => {
  localStorage.setItem("admin_"+key, value);
};

export const getItem = (key) => {
  const value = localStorage.getItem("admin_"+key);
  return value;
};

export const removeItem = (key) => {
  localStorage.removeItem("admin_"+key);
};
